import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import { ArrowIcon, ModalCloseIcon } from 'public/assets';

import { useChatPlayContext } from '@provider/ChatPlayProvider';

const ChatADFloating = () => {
  const { t } = useTranslation();
  const { isShowFloatingAD, onCloseFloatingAD } = useChatPlayContext();
  const router = useRouter();

  if (!isShowFloatingAD) {
    return null;
  }

  const onStopPropagation = (
    e: React.MouseEvent<HTMLDivElement> | MouseEvent,
  ) => {
    e.stopPropagation();
  };

  const onGoStory = (e: React.MouseEvent<HTMLDivElement> | MouseEvent) => {
    router.push({
      pathname: `/story/141`,
      query: {
        section: 'home',
        from: '채팅_플로팅',
      },
    });
    onCloseFloatingAD();
    onStopPropagation(e);
  };

  const onClose = (e: React.MouseEvent<HTMLDivElement> | MouseEvent) => {
    onCloseFloatingAD();
    onStopPropagation(e);
  };

  return (
    <div css={container} onClick={onStopPropagation}>
      <div className="info">
        <Image
          alt="mbti19-logo"
          src={`/assets/image_mbti19_floating.png`}
          width={60}
          height={60}
        />
        <div className="content">
          <div className="title">{t('chat_toast_title_mbti19_dating')}</div>
          <div className="button" onClick={onGoStory}>
            {t('chat_toast_title_going_to_see_the_spicy')}
            <ArrowIcon className="icon" />
          </div>
        </div>
      </div>
      <div className="close" onClick={onClose}>
        <ModalCloseIcon />
      </div>
    </div>
  );
};

const container = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.75rem;
  gap: 0.75rem;
  position: absolute;
  width: 22.5rem;
  left: 50%;
  top: 1.5rem;
  transform: translateX(-50%);
  cursor: auto;
  background: ${theme.colors.white};
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.25);
  border-radius: 0.75rem;
  animation: down 450ms ease-in-out;

  .info {
    flex-shrink: 1;
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .content {
    flex-shrink: 1;
  }

  .title {
    font: ${theme.font.body1Bold};
    display: flex;
    align-items: center;
    letter-spacing: -0.3px;
    color: ${theme.colors.gray900};
  }

  .button {
    font: ${theme.font.body2Normal};
    white-space: nowrap;
    letter-spacing: -0.3px;
    color: ${theme.colors.red500};
    flex-shrink: 1;
    cursor: pointer;
    display: flex;
    align-items: center;

    .icon {
      margin-bottom: 0.125rem;
    }
  }

  .close {
    flex-shrink: 1;
    margin-top: -0.4688rem;
    margin-right: -0.4688rem;
    cursor: pointer;
  }

  @media screen and (max-width: ${theme.devices.mobile}) {
    width: 15.875rem;
  }

  @keyframes down {
    0% {
      top: -5.5rem;
    }

    80% {
      top: 1.75rem;
    }

    100% {
      top: 1.5rem;
    }
  }
`;

export default ChatADFloating;
